import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { loginUrl } from '@/urls'
import useLastPath from './useLastPath'

const buildReturnPath = loc => (loc?.pathname || '') + (loc?.search || '')

/**
 * Open the login route-modal and always persist return context for
 * in-app close (state.returnUrl) and OAuth /callback (localStorage lastPath).
 */
const useOpenLogin = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { setLastPath } = useLastPath()

  const openLogin = useCallback(
    (options = {}) => {
      const { replace = false, returnTo } = options
      const returnUrl = returnTo ?? buildReturnPath(location)
      setLastPath(returnUrl)
      navigate(loginUrl(), { replace, state: { returnUrl } })
    },
    [navigate, location, setLastPath]
  )

  return { openLogin }
}

export default useOpenLogin
